import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedMessage } from 'react-intl';
import browserHistory from 'react-router/lib/browserHistory';

import { ActivityContentWrap } from './ActivityContentWrap';
import { getNotificationDetailsByType, getNotificationType } from './utils';
import { CommunityCard } from '../CommunityCard';
import { TimeShow } from '../../../common/TimeShow';
import Label from '../../../common/Label';
import Button from '../../../Button';
import { COMMUNITIES } from '../../../../constants/routes';
import styl from './index.styl';

const NotificationListItem = ({
  createdAt,
  onClick,
  hasNewLabel,
  newLabelText,
  subject,
}) => {
  const type = getNotificationType(subject);
  const {
    community: { id: communityId, name },
  } = subject;
  const {
    translationKey,
    extraTitle,
    logo,
    route,
    id,
    title,
  } = getNotificationDetailsByType(type, subject);

  return (
    <CommunityCard
      avatar={{
        src: logo,
        size: 100,
        name: title,
      }}
      renderTitle={() => (
        <div className="pointer" onClick={() => onClick(id, route)}>
          <span>{title}</span> {extraTitle}
          {hasNewLabel && (
            <Label
              text={newLabelText}
              className="ml1 relative"
              additionalClass="uppercase"
            />
          )}
        </div>
      )}
      renderContent={() => (
        <FormattedMessage
          id={translationKey}
          values={{
            communityName: (
              <ActivityContentWrap
                onClick={() => onClick(communityId, 'community')}
                text={name}
              />
            ),
          }}
        />
      )}
      renderInfo={() => <TimeShow timestamp={createdAt} />}
      renderActions={() =>
        subject.approvalStatus === 'approved' && (
          <Button
            color="primary"
            onClick={() =>
              browserHistory.push(
                `${COMMUNITIES}/${communityId}/post/${subject.id}`,
              )
            }
          >
            <FormattedMessage id="community.activity.openPost" />
          </Button>
        )
      }
    />
  );
};

NotificationListItem.propTypes = {
  createdAt: PropTypes.string.isRequired,
  subject: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  newLabelText: PropTypes.string,
  hasNewLabel: PropTypes.bool,
};

NotificationListItem.defaultProps = {
  onClick: null,
  newLabelText: '',
  hasNewLabel: false,
};

export default CSSModules(NotificationListItem, styl, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Communities/Components/ActivitiesList/NotificationListItem.jsx